import React from "react";
import { Field, GenericFieldHTMLAttributes } from "redux-form";

interface SelectOption {
    label: string;
    value: string | number;
    header?: boolean;
}

interface CustomExtendedFieldProps {
    onChangeCapture?: (event: any) => void;
    options?: SelectOption[];
    renderEmptyCellItem?: boolean;
    adornment?: string;
}

export default class CustomExtendedField extends Field<
    GenericFieldHTMLAttributes & CustomExtendedFieldProps & { label?: string }
> {}



// WEBPACK FOOTER //
// ./src/components/form/CustomExtendedField.tsx